import { Checkbox } from 'antd';
import React, { FC } from 'react';

import { JCheckboxGroupProps } from './../../models';
import { GenericRadioContainer } from './GenericRadioContainer';
import {useJCommonContext} from "../../../JCommonProvider";

export const JCheckboxGroup: FC<JCheckboxGroupProps> = (props) => {
    const {getImageURL} = useJCommonContext();
    return(
        <GenericRadioContainer {...props}>
            {!!props.overrideValue && props.overrideValue !== null
                ? <></>
                : <Checkbox.Group disabled={props.disabled}>
                    {
                        props.options.map((option, i) => (
                            <Checkbox
                                key={i}
                                value={option.value}
                                className={option.imageURL && 'with-image'}
                                aria-describedby={props.validationMessage}
                            >

                                {
                                    option.label && (
                                        <div className='checkbox-text'>{option.label}</div>
                                    )
                                }

                                {option.imageURL && <img src={getImageURL(option.imageURL)} aria-hidden={true}/>}
                            </Checkbox>
                        ))
                    }
                </Checkbox.Group>}
        </GenericRadioContainer>
    )
}
